// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Photo from './Photo';
import { tabletThresholdPixels } from '../../home/v4/styledComponents';

const Container = styled.div`
  width: 480px;
  height: 100%;

  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
  }
`;

function BlockPhoto({ src, alt, source }) {
  const { t } = useTranslation();
  return (
    <Container>
      <Photo
        src={src.publicURL}
        alt={t(alt)}
        source={source}
      />
    </Container>
  );
}

BlockPhoto.propTypes = {
  src: PropTypes.shape({
    publicURL: PropTypes.string.isRequired,
  }).isRequired,
  alt: PropTypes.string.isRequired,
  source: PropTypes.string,
};

BlockPhoto.defaultProps = {
  source: null,
};

export default BlockPhoto;
